import { Card, PreparedServerCard } from '../types';
import { checkIsSavedCard } from './checkIsSavedCard';

export const checkIsVirtualCard = (activeCard: Card, cards: PreparedServerCard[]): boolean => {
  if (checkIsSavedCard(activeCard)) {
    return cards.some((card) => card.isOTTCard && card.id === activeCard.id);
  }

  return false;
};
